import { PERMISSIONS } from 'contexts/PermissionsContext';

export const ROOT_ROUTE = '/spend-controller';

export const CONFIG = [
	{
		path: `${ROOT_ROUTE}/baseline`,
		name: 'baseline',
		label: 'Baseline',
		requiredSome: [PERMISSIONS.BaselineRead],
	},
	{
		path: `${ROOT_ROUTE}/preworkshop-template`,
		name: 'preworkshoptemplate',
		label: 'Pre-WorkShop Template',
		requiredSome: [PERMISSIONS.PreWorkShopRead],
	},
	{
		path: `${ROOT_ROUTE}/workshop`,
		name: 'workshop',
		label: 'WorkShop',
		requiredSome: [PERMISSIONS.WorkShopRead],
	},
	{
		path: `${ROOT_ROUTE}/saving-sign-off`,
		name: 'savingSignOff',
		label: 'Saving Sign Off',
		requiredSome: [PERMISSIONS.SavingsSignOffRead],
	},
	{
		path: `${ROOT_ROUTE}/micro-tail-launch`,
		name: 'microTailLaunch',
		label: 'Micro Tail Launch',
		requiredSome: [PERMISSIONS.MicroTailRead],
	},
	{
		path: `${ROOT_ROUTE}/finance-report`,
		name: 'financeReport',
		label: 'Finance Report',
		requiredSome: [PERMISSIONS.FinanceReportRead],
	},
];
